// @flow

import GenericRelationResource from 'esm-web-pro/api/resources/GenericRelationResource';

export default class CommentResource extends GenericRelationResource {
    basePath: string = 'comments/{appLabel}/{contentType}/{objectId}/';

    objectPath: string = 'comments/{appLabel}/{contentType}/{objectId}/{ident}/';
}
